// User interactions
export const CTPM_START_WORKFLOW = 'CTPM_START_WORKFLOW'
export const CTPM_FINISHED_WORKFLOW = 'CTPM_FINISHED_WORKFLOW'
export const CTPM_SELECT_PIN_TO_MAP = 'CTPM_SELECT_PIN_TO_MAP'
export const CTPM_SELECT_PIN_TO_UNMAP = 'CTPM_SELECT_PIN_TO_UNMAP'
export const CTPM_CANCEL_CTP_MAPPING = 'CTPM_CANCEL_CTP_MAPPING'
export const CTPM_SAVE_CTP_MAPPING = 'CTPM_SAVE_CTP_MAPPING'

// Modals
export const CTPM_SHOW_CTP_MAPPING_MODAL = 'CTPM_SHOW_CTP_MAPPING_MODAL'

// Data
export const CTPM_PREP_DATA = 'CTPM_PREP_DATA'
export const CPTM_SET_ASSIGNMENTS = 'CPTM_SET_ASSIGNMENTS'
export const CPTM_STAGE_ASSIGNMENTS = 'CPTM_STAGE_ASSIGNMENTS'
export const CTPM_CLEAN_UP = 'CTPM_CLEAN_UP'
export const CTPM_CLEAN_UP_ON_SAVE = 'CTPM_CLEAN_UP_ON_SAVE'
